module.exports = __webpack_public_path__ + "img/thumbnail_BEMA Color.a10bf2c7.png";